"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault")["default"];
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.History = void 0;
var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));
var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var History = /*#__PURE__*/function () {
  function History() {
    (0, _classCallCheck2["default"])(this, History);
    this.lock = false;
    this.lockedGlobal = false;
    this.mementos = [];
    this.actualState = -1;
  }
  (0, _createClass2["default"])(History, [{
    key: "setUndoLocked",
    value: function setUndoLocked(locked) {
      this.lockedGlobal = locked;
    }
  }, {
    key: "reset",
    value: function reset() {
      while (this.mementos.length > 0) {
        this.mementos.pop();
      }
    }
  }, {
    key: "saveState",
    value: function saveState(memento) {
      if (this.lock || this.lockedGlobal) {
        console.log("save locked!");
        return;
      }
      if (this.mementos.length == 11) {
        this.mementos.shift();
        this.actualState = this.actualState - 1;
      }
      console.log("saveState");
      if (this.mementos.length == this.actualState + 1) {
        this.mementos.push(memento);
        this.actualState = this.mementos.length - 1;
      } else {
        var _context;
        this.mementos = (0, _slice["default"])(_context = this.mementos).call(_context, 0, this.actualState + 1);
        this.mementos.push(memento);
        this.actualState = this.mementos.length - 1;
      }
    }
  }, {
    key: "redo",
    value: function redo() {
      var _this = this;
      this.lock = true;
      return new _promise["default"](function (resolve, rejct) {
        try {
          if (_this.actualState + 1 == _this.mementos.length) {
            _this.lock = false;
            resolve(null);
          } else {
            var memento = _this.mementos[_this.actualState + 1];
            memento.execute().then(function (toRedraw) {
              _this.actualState++;
              _this.lock = false;
              resolve(toRedraw);
            })["catch"](function (error) {
              _this.lock = false;
              rejct(error);
            });
          }
        } catch (e) {
          console.log(e);
          _this.lock = false;
          rejct(e);
        }
      });
    }
  }, {
    key: "undo",
    value: function undo() {
      var _this2 = this;
      this.lock = true;
      return new _promise["default"](function (resolve, reject) {
        if (_this2.actualState <= 0) {
          _this2.lock = false;
          resolve(null);
        } else {
          var memento = _this2.mementos[_this2.actualState - 1];
          memento.execute().then(function (toRedraw) {
            _this2.actualState--;
            _this2.lock = false;
            resolve(toRedraw);
          })["catch"](function (error) {
            console.error(error);
            _this2.lock = false;
            reject(error);
          });
        }
      });
    }
  }, {
    key: "isFirstUndo",
    value: function isFirstUndo() {
      return this.actualState === 0;
    }
  }, {
    key: "isLastUndo",
    value: function isLastUndo() {
      return this.actualState == this.mementos.length - 1;
    }
  }]);
  return History;
}();
exports.History = History;
//# sourceMappingURL=History.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@3cad/nextcore/lib/commonjs/patterns/History.js
// module id = 1142
// module chunks = 142